import { SOCKET_NOT_TAKEN } from "../types";

export interface IdentifyEntityRoute {
  id: string;
  entityId: string;
}

export function notTakenRouteSockets(
  routes: IdentifyEntityRoute[],
  socketIdByRouteId: Map<string, string>,
  enableOthersRoute: boolean,
): Record<string, unknown> {
  const output: Record<string, unknown> = {};
  for (const route of routes) {
    if (typeof route.id !== "string" || route.id.length === 0) continue;
    const socketId = socketIdByRouteId.get(route.id);
    if (socketId === undefined) continue;
    output[socketId] = SOCKET_NOT_TAKEN;
  }
  if (enableOthersRoute) {
    output.others = SOCKET_NOT_TAKEN;
  }
  return output;
}

export function applyMatchedIdentifyRoute(opts: {
  output: Record<string, unknown>;
  routes: IdentifyEntityRoute[];
  socketIdByRouteId: Map<string, string>;
  enableOthersRoute: boolean;
  othersEmitNullWhenNoMatch: boolean;
  isMatched: boolean;
  matchedEntityId: string | null;
  entityRef: unknown;
}): void {
  if (opts.isMatched && opts.matchedEntityId != null) {
    const matchedRoute = opts.routes.find(
      (route) => route.entityId === opts.matchedEntityId,
    );
    const matchedRouteSocketId = matchedRoute
      ? opts.socketIdByRouteId.get(matchedRoute.id)
      : undefined;
    if (matchedRoute && matchedRouteSocketId !== undefined) {
      opts.output[matchedRouteSocketId] = opts.entityRef;
      return;
    }
    if (opts.enableOthersRoute) {
      opts.output.others = opts.entityRef;
    }
    return;
  }
  if (opts.enableOthersRoute && opts.othersEmitNullWhenNoMatch) {
    opts.output.others = null;
  }
}

/**
 * Shared output map for identify_customer / identify_supplier.
 *
 * Branch sockets are initialized to SOCKET_NOT_TAKEN so skip propagation
 * treats unchosen routes as explicitly not taken. Eval/context fields are
 * written last so a misconfigured route id cannot clobber them.
 */
export function buildIdentifyEntityStepOutput(input: {
  socketIdByRouteId: Map<string, string>;
  routes: IdentifyEntityRoute[];
  enableOthersRoute: boolean;
  othersEmitNullWhenNoMatch: boolean;
  isMatched: boolean;
  matchedEntityId: string | null;
  entityRef: unknown;
  topPick: unknown;
  evalFields: Record<string, unknown>;
}): Record<string, unknown> {
  const output = notTakenRouteSockets(
    input.routes,
    input.socketIdByRouteId,
    input.enableOthersRoute,
  );
  output.top_pick = input.isMatched ? input.topPick : SOCKET_NOT_TAKEN;
  applyMatchedIdentifyRoute({
    output,
    routes: input.routes,
    socketIdByRouteId: input.socketIdByRouteId,
    enableOthersRoute: input.enableOthersRoute,
    othersEmitNullWhenNoMatch: input.othersEmitNullWhenNoMatch,
    isMatched: input.isMatched,
    matchedEntityId: input.matchedEntityId,
    entityRef: input.entityRef,
  });
  return { ...output, ...input.evalFields };
}
